import { useLingui } from '@lingui/react';
import { Field, FieldProps } from 'formik';
import { isDELocale, SupportedLocales } from '../countryHelper';
import styles from './MarketingCheckbox.module.css';

const MarketingCheckbox = () => {
  const lingui = useLingui();
  if (isDELocale(lingui.i18n.locale as SupportedLocales)) {
    return <MarketingCheckboxDE />;
  }

  return (
    <div className={styles.marketingOption}>
      <Field name="email_marketing_opt_in">
        {({ field }: FieldProps) => (
          <input
            {...field}
            id="email_marketing_opt_in"
            type="checkbox"
            checked={field.value}
          />
        )}
      </Field>
      <label htmlFor="email_marketing_opt_in">
        <strong>Sign up for updates</strong> – we’ll email offers and stories
        from other small businesses.
      </label>
    </div>
  );
};

const MarketingCheckboxDE = () => {
  return (
    <div className={styles.marketingOptionDE}>
      <div className={styles.marketingOptionDECheckbox}>
        <Field name="email_marketing_opt_in">
          {({ field }: FieldProps) => (
            <input
              {...field}
              id="email_marketing_opt_in"
              type="checkbox"
              checked={field.value}
            />
          )}
        </Field>
        <label htmlFor="email_marketing_opt_in">
          Ich willige ein, dass die iwoca Deutschland GmbH mich in Zukunft
          regelmäßig über ihre Angebote zu Krediten und ihren weiteren
          Finanzierungsprodukten für Unternehmen per E-Mail informiert. Mir ist
          bekannt, dass ich diese Einwilligung jederzeit, beispielsweise über
          den in den E-Mails enthaltenen Abmeldelink, mit Wirkung für die
          Zukunft widerrufen kann.
        </label>
      </div>
    </div>
  );
};

export default MarketingCheckbox;
